import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-lg font-bold text-gary-text-color justify-center mb-[10px]" }, [
  /*#__PURE__*/_createElementVNode("div", null, "宅配-收件人")
], -1)
const _hoisted_3 = { class: "flex flex-col max-h-[400px] overflow-auto" }
const _hoisted_4 = { class: "flex flex-col gap-1" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = { class: "text-[11px] w-[80%] text-light-gary-text-color" }
const _hoisted_8 = { class: "w-[80px] mt-3 sm:mt-1" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mt-[12px] flex justify-center gap-2.5" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 新增地址 ")
const _hoisted_12 = {
  key: 1,
  class: ""
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-lg font-bold text-gary-text-color justify-center mb-[10px]" }, [
  /*#__PURE__*/_createElementVNode("div", null, "門店取貨-收件人")
], -1)
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "flex flex-col gap-1" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "text-xs" }
const _hoisted_18 = { class: "text-[11px] w-[80%] text-light-gary-text-color md:whitespace-nowrap" }
const _hoisted_19 = { class: "text-[11px] w-[100%] text-light-gary-text-color md:whitespace-nowrap" }
const _hoisted_20 = { class: "w-[80px] mt-3 sm:mt-1" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "mt-[12px] flex justify-center gap-2.5" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 新增取貨門店 ")
const _hoisted_24 = {
  key: 2,
  class: ""
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-lg font-bold text-gary-text-color justify-center mb-[10px]" }, [
  /*#__PURE__*/_createElementVNode("div", null, "收件人資料")
], -1)
const _hoisted_26 = { class: "flex flex-col mt-2.5 mr-0 sm:mr-[2.375rem]" }
const _hoisted_27 = { class: "flex gap-3 mt-8 justify-center" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = {
  key: 3,
  class: ""
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-lg font-bold text-gary-text-color justify-center mb-[10px]" }, [
  /*#__PURE__*/_createElementVNode("div", null, "收件人資料")
], -1)
const _hoisted_32 = { class: "flex flex-col mt-2.5 mr-[2.375rem]" }
const _hoisted_33 = { class: "text-sm text-left inline-block" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "input-label relative font-light pt-2 pb-3 text-breadcrumb-color tracking-widest required" }, [
  /*#__PURE__*/_createTextVNode(" 選擇門店"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-dot bg-dot-red" })
], -1)
const _hoisted_35 = { class: "flex gap-2 mt-2" }
const _hoisted_36 = { class: "w-[37%]" }
const _hoisted_37 = { class: "w-[62%]" }
const _hoisted_38 = {
  key: 0,
  class: "text-[11px] w-[80%] font-light text-light-gary-text-color md:whitespace-nowrap"
}
const _hoisted_39 = {
  key: 1,
  class: "text-[11px] w-[100%] font-light mt-[6px] text-light-gary-text-color md:whitespace-nowrap"
}
const _hoisted_40 = { class: "flex gap-3 mt-8 justify-center" }
const _hoisted_41 = { class: "" }
const _hoisted_42 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Input = _resolveComponent("Input")!
  const _component_AddressInput = _resolveComponent("AddressInput")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ModalBase = _resolveComponent("ModalBase")!
  const _component_ModalConfirm = _resolveComponent("ModalConfirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalBase, {
      show: _ctx.show,
      class: "g-address-modal modal-510-width"
    }, {
      body: _withCtx(() => [
        _createVNode(_component_Icon, {
          iconName: "modal-close",
          class: "absolute top-4 right-4 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
          _ctx.resetAll();
          _ctx.$emit('ok');
        })
        }),
        (_ctx.contentType === _ctx.DeliveryModalContentType.HOME_LIST)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryAddrList, (deliveryAddrItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: deliveryAddrItem.DeliveryAddrId,
                    class: "flex border-[1px] sm:mb-2.5 rounded py-2.5 px-4 sm:p-[16px] justify-between"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(deliveryAddrItem.ReceiverName), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(deliveryAddrItem.ReceiverMobile), 1),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(deliveryAddrItem.DeliveryCity +
                  deliveryAddrItem.DeliveryDist +
                  deliveryAddrItem.DeliveryAddr), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.setSelectDelivery(deliveryAddrItem)),
                        class: _normalizeClass(["h-[30px] cursor-pointer text-center text-xs leading-[30px] rounded-md text-white", [
                  {
                    'bg-primary-color': deliveryAddrItem.IsDefault === 1,
                    'bg-black-400-color': deliveryAddrItem.IsDefault === 0
                  }
                ]])
                      }, " 使用地址 ", 10, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_Icon, {
                          onClick: ($event: any) => (_ctx.setEditDeliveryDetail(deliveryAddrItem)),
                          class: "cursor-pointer",
                          iconName: "circle_edit",
                          width: '20px'
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Icon, {
                          onClick: ($event: any) => (_ctx.remove(deliveryAddrItem)),
                          class: "cursor-pointer",
                          iconName: "circle_close",
                          width: '20px'
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", {
                class: "my-[16px] flex gap-2 text-gary-text-color tracking-[.06em] cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToAddAddress && _ctx.goToAddAddress(...args)))
              }, [
                _createVNode(_component_Icon, {
                  iconName: "add_black",
                  width: '24px'
                }),
                _hoisted_11
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.contentType === _ctx.DeliveryModalContentType.SHOP_LIST)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryShopList, (deliveryShop) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: deliveryShop.DeliveryShopId,
                    class: "flex border-[1px] sm:mb-2.5 rounded py-2.5 px-4 sm:p-[16px] justify-between"
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(deliveryShop.ShopInfo.ShopName), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(deliveryShop.ReceiverName) + "  " + _toDisplayString(deliveryShop.ReceiverMobile), 1),
                      _createElementVNode("div", _hoisted_18, " 據點地址｜" + _toDisplayString(deliveryShop.ShopInfo.ShopAddr), 1),
                      _createElementVNode("div", _hoisted_19, " 營業時間｜" + _toDisplayString(deliveryShop.ShopInfo.BusinessHours), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.setSelectShopDelivery(deliveryShop)),
                        class: _normalizeClass(["h-[30px] cursor-pointer text-center text-xs leading-[30px] rounded-md text-white", [
                  {
                    'bg-primary-color': deliveryShop.IsDefault === 1,
                    'bg-black-400-color': deliveryShop.IsDefault === 0
                  }
                ]])
                      }, " 使用門店 ", 10, _hoisted_21),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_Icon, {
                          iconName: "circle_edit",
                          class: "cursor-pointer",
                          width: '20px',
                          onClick: ($event: any) => (_ctx.setEditShopDetail(deliveryShop))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Icon, {
                          iconName: "circle_close",
                          class: "cursor-pointer",
                          width: '20px',
                          onClick: ($event: any) => (_ctx.remove(deliveryShop))
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", {
                class: "my-[16px] flex gap-2 text-gary-text-color tracking-[.06em] cursor-pointer",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToAddShop && _ctx.goToAddShop(...args)))
              }, [
                _createVNode(_component_Icon, {
                  iconName: "add_black",
                  width: '24px'
                }),
                _hoisted_23
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.contentType === _ctx.DeliveryModalContentType.HOME_ADD)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              (_ctx.deliveryAddrId === '')
                ? (_openBlock(), _createBlock(_component_Toggle, {
                    key: 0,
                    modelValue: _ctx.isSameMemberInfo,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isSameMemberInfo) = $event)),
                    class: "py-2",
                    label: '同訂購人資料'
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_Input, {
                  label: '收件人姓名',
                  class: "under-line mb-5",
                  width: '248px',
                  required: true,
                  modelValue: _ctx.receiverName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.receiverName) = $event)),
                  placeholder: "請輸入姓名"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Input, {
                  label: '收件者手機',
                  class: "under-line",
                  width: '248px',
                  required: true,
                  modelValue: _ctx.receiverMobile,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.receiverMobile) = $event)),
                  placeholder: "請輸入手機號碼(格式：09XXXXXXXX)"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_AddressInput, {
                  deliveryAddr: _ctx.deliveryAddr,
                  "onUpdate:deliveryAddr": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.deliveryAddr) = $event)),
                  deliveryDist: _ctx.deliveryDist,
                  "onUpdate:deliveryDist": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.deliveryDist) = $event)),
                  deliveryCity: _ctx.deliveryCity,
                  "onUpdate:deliveryCity": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.deliveryCity) = $event)),
                  deliveryZip: _ctx.deliveryZip,
                  "onUpdate:deliveryZip": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.deliveryZip) = $event)),
                  required: true,
                  label: '地址'
                }, null, 8, ["deliveryAddr", "deliveryDist", "deliveryCity", "deliveryZip"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Btn, {
                    text: '取消',
                    height: '36px',
                    width: '121px',
                    type: 'light',
                    required: true,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => {
                _ctx.contentType = _ctx.DeliveryModalContentType.HOME_LIST;
                _ctx.resetInfo();
              })
                  })
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_Btn, {
                    text: '確認',
                    height: '36px',
                    width: '121px',
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editAddrDetail()))
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.contentType === _ctx.DeliveryModalContentType.SHOP_ADD)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _hoisted_31,
              (_ctx.deliveryShopId === '')
                ? (_openBlock(), _createBlock(_component_Toggle, {
                    key: 0,
                    modelValue: _ctx.isSameMemberInfo,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isSameMemberInfo) = $event)),
                    class: "py-2",
                    label: '同訂購人資料'
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_Input, {
                  label: '收件人姓名',
                  class: "under-line mb-5",
                  width: '248px',
                  required: true,
                  modelValue: _ctx.receiverName,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.receiverName) = $event)),
                  placeholder: "請輸入姓名"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Input, {
                  label: '收件者手機',
                  class: "under-line mb-5",
                  width: '248px',
                  required: true,
                  placeholder: "請輸入手機號碼(格式：09XXXXXXXX)",
                  modelValue: _ctx.receiverMobile,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.receiverMobile) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_Select, {
                        class: "mb-3 w-full",
                        width: '49%',
                        itemList: _ctx.cartStore.state.deliveryShopCityList,
                        itemValue: 'CityName',
                        itemText: 'CityName',
                        modelValue: _ctx.selectDeliveryCity,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectDeliveryCity) = $event)),
                        onChange: _ctx.setCity
                      }, null, 8, ["itemList", "modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_Select, {
                        class: "mb-3 w-full",
                        width: '49%',
                        itemList: _ctx.cartStore.state.deliveryShopFilterByRegionList,
                        itemValue: 'ShopCode',
                        itemText: 'ShopName',
                        modelValue: _ctx.selectDeliveryShop,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectDeliveryShop) = $event))
                      }, null, 8, ["itemList", "modelValue"])
                    ])
                  ])
                ]),
                (_ctx.selectDeliveryShop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, " 據點地址｜" + _toDisplayString(_ctx.find(_ctx.cartStore.state.deliveryShopFilterByRegionList, {
                ShopCode: _ctx.selectDeliveryShop
              }).ShopAddr), 1))
                  : _createCommentVNode("", true),
                (_ctx.selectDeliveryShop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, " 營業時間｜" + _toDisplayString(_ctx.find(_ctx.cartStore.state.deliveryShopFilterByRegionList, {
                ShopCode: _ctx.selectDeliveryShop
              }).BusinessHours), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_Btn, {
                    text: '取消',
                    height: '36px',
                    width: '121px',
                    type: 'light',
                    required: true,
                    onClick: _cache[17] || (_cache[17] = ($event: any) => {
                _ctx.contentType = _ctx.DeliveryModalContentType.SHOP_LIST;
                _ctx.resetInfo();
              })
                  })
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_Btn, {
                    text: '確認',
                    height: '36px',
                    width: '121px',
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.editShopDetail()))
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ModalConfirm, { ref: "confirmModal" }, null, 512)
  ], 64))
}